import * as React from "react";
import Loadable from "react-loadable";
import OptionsWithoutRender = LoadableExport.OptionsWithoutRender;
import { Loader } from "../page/loader";

interface ComponentProps {}

type Props = ComponentProps;

const loadableOptions: OptionsWithoutRender<Props> = {
  loader: () => import("../../modules/exclusive-event-page").then((module) => module.ExclusiveEventPage) as Promise<any>,
  loading: () => <Loader isActive={true} />,
};

export const ExclusiveEventPage = Loadable(loadableOptions);